/**
 * @description: 左上-总体概览
 * value：标题label对应的值
 * subValue：小标题subLabel对应的值
 */
const overviewData = [
  {
    label: '镇街整体企业数',
    value: '77,909',
    subLabel: '已辨识企业数',
    subValue: '7,909',
    progress: 100
  },
  {
    label: '风险点个数',
    value: '77,909',
    subLabel: '已辨识风险点个数',
    subValue: '47,909',
    progress: 50
  },
  { label: '风险告知卡数', value: '677,909', subLabel: '', subValue: '' },
  { label: '特殊(危险)作业数', value: '677,909', subLabel: '', subValue: '' }
]

/**
 * @description: 左中-固有风险
 * value：对应风险等级的数值
 */
const inherentRiskChart = [
  { value: 12, name: '重大风险', color: 'red' },
  { value: 61, name: '较大风险', color: 'orange' },
  { value: 54, name: '一般风险', color: 'yellow' },
  { value: 2, name: '低风险', color: 'blue' }
]
/**
 * @description: 左中-现有风险
 * value：对应风险等级的数值
 */
const existingRiskChart = [
  { value: 10, name: '重大风险', color: 'red' },
  { value: 5, name: '较大风险', color: 'orange' },
  { value: 54, name: '一般风险', color: 'yellow' },
  { value: 20, name: '低风险', color: 'blue' }
]

/**
 * @description: 左下-企业类型
 * value：对应企业类型的数值
 */
const enterpriseTypeChart = [
  { value: 12, name: '生产', color: 'red' },
  { value: 61, name: '储存', color: 'orange' },
  { value: 54, name: '使用', color: 'yellow' },
  { value: 2, name: '其他', color: 'blue' }
]
/**
 * @description: 左下-企业运行状态统计
 * value：对应状态的数值
 */
const operatingStatusChart = [
  { value: 11, name: '营业', color: 'red' },
  { value: 8, name: '停业(歇业)', color: 'orange' },
  { value: 1, name: '筹建', color: 'blue' },
  { value: 2, name: '关闭', color: 'green' },
  { value: 5, name: '破产', color: 'yellow' },
  { value: 2, name: '其他', color: 'grey' }
]

/**
 * @description: 右上-企业风险辨识排行
 * name：企业名称
 * total：风险点总数
 * greatRisk：重大
 * highRisk：较大
 * generalRisk：一般
 * lowRisk：低
 */
const riskRanking = [
  {
    name: '宜品乳液科技股份有限公司',
    total: 293,
    greatRisk: 179,
    highRisk: 77,
    generalRisk: 15,
    lowRisk: 7
  },
  {
    name: '千盛餐欽有限公司',
    total: 293,
    greatRisk: 179,
    highRisk: 77,
    generalRisk: 15,
    lowRisk: 8
  },
  {
    name: '巨正源料科技有限公司',
    total: 293,
    greatRisk: 179,
    highRisk: 77,
    generalRisk: 15,
    lowRisk: 7
  },
  {
    name: '东莞三江港口储罐有限公司',
    total: 293,
    greatRisk: 179,
    highRisk: 77,
    generalRisk: 15,
    lowRisk: 7
  },
  {
    name: '广东丽臣奥威实业科技股份有限公司',
    total: 293,
    greatRisk: 179,
    highRisk: 77,
    generalRisk: 15,
    lowRisk: 7
  },
  {
    name: '企业广东大彤化工有限公司名称',
    total: 293,
    greatRisk: 179,
    highRisk: 77,
    generalRisk: 15,
    lowRisk: 7
  },
  {
    name: '企业名称企业名称企业名称企业名称企业名称企业名称企业名称',
    total: 293,
    greatRisk: 179,
    highRisk: 77,
    generalRisk: 15,
    lowRisk: 7
  },
  { name: '企业名称', total: 293, greatRisk: 179, highRisk: 77, generalRisk: 15, lowRisk: 7 },
  { name: '企业名称', total: 293, greatRisk: 179, highRisk: 77, generalRisk: 15, lowRisk: 7 },
  { name: '企业名称', total: 293, greatRisk: 179, highRisk: 77, generalRisk: 15, lowRisk: 7 }
]

/**
 * @description: 右中-企业风险点数量展示
 * id：该项数据的唯一id
 * name：企业名称
 * inherentRisk固有风险数据：{ greatRisk：重大风险值，highRisk: 较大风险值, generalRisk: 一般风险值, lowRisk: 低风险值 }
 * existingRisk现状风险数据：{ greatRisk：重大风险值，highRisk: 较大风险值, generalRisk: 一般风险值, lowRisk: 低风险值 }
 */
const riskPoints = [
  {
    id: '0',
    name: '东莞虎门港海湾石油仓储码头有限公司',
    inherentRisk: { greatRisk: 179, highRisk: 77, generalRisk: 15, lowRisk: 7 },
    existingRisk: { greatRisk: 179, highRisk: 77, generalRisk: 15, lowRisk: 7 }
  },
  {
    id: '1',
    name: '东莞市东洲国际石化仓储有限公司',
    inherentRisk: { greatRisk: 179, highRisk: 77, generalRisk: 15, lowRisk: 1 },
    existingRisk: { greatRisk: 179, highRisk: 77, generalRisk: 15, lowRisk: 7 }
  },
  {
    id: '2',
    name: '企业名称企业名称企业名称企业名称企业名称企业名称',
    inherentRisk: { greatRisk: 179, highRisk: 77, generalRisk: 15, lowRisk: 7 },
    existingRisk: { greatRisk: 179, highRisk: 77, generalRisk: 15, lowRisk: 7 }
  },
  {
    id: '3',
    name: '企业名称企业名称企业名称企业名称企业名称企业名称',
    inherentRisk: { greatRisk: 179, highRisk: 77, generalRisk: 15, lowRisk: 7 },
    existingRisk: { greatRisk: 179, highRisk: 77, generalRisk: 15, lowRisk: 7 }
  },
  {
    id: '4',
    name: '企业名称企业名称企业名称企业名称企业名称企业名称',
    inherentRisk: { greatRisk: 179, highRisk: 77, generalRisk: 15, lowRisk: 7 },
    existingRisk: { greatRisk: 179, highRisk: 77, generalRisk: 15, lowRisk: 7 }
  }
]

/**
 * @description: 右下-xxx企业风险点信息展示
 * id：需要与riskPoints的id一一对应
 * name：右下角模块的标题是name + 风险点信息展示
 * list具体风险点信息：[
 *   name: 风险点名称,
 *   inherentRiskLevel: 固有风险等级，0-低风险 1-一般风险 2-较大风险 3-重大风险
 *   existingRiskLevel: 现有风险等级，0-低风险 1-一般风险 2-较大风险 3-重大风险
 * ]
 */
const riskDetails = [
  {
    id: '0',
    name: '东莞虎门港海湾石油仓储',
    list: [
      {
        name: '油台装车作业',
        inherentRiskLevel: 0, // 0-低风险 1-一般风险 2-较大风险 3-重大风险
        existingRiskLevel: 1,
        edge: 'start'
      },
      {
        name: '储罐输转作业',
        inherentRiskLevel: 1,
        existingRiskLevel: 2
      },
      {
        name: '储罐脱水作业',
        inherentRiskLevel: 2,
        existingRiskLevel: 3
      },
      {
        name: '储罐清洗作业',
        inherentRiskLevel: 2,
        existingRiskLevel: 3
      },
      {
        name: '风险点名称',
        inherentRiskLevel: 2,
        existingRiskLevel: 3
      },
      {
        name: '风险点名称',
        inherentRiskLevel: 2,
        existingRiskLevel: 3
      },
      {
        name: '风险点名称风险点名称风险点名称风险点名称',
        inherentRiskLevel: 0,
        existingRiskLevel: 0,
        edge: 'end'
      }
    ]
  },
  {
    id: '1',
    name: '东莞市东洲国际石化仓储',
    list: [
      {
        name: '2',
        inherentRiskLevel: 0, // 0-低风险 1-一般风险 2-较大风险 3-重大风险
        existingRiskLevel: 1,
        edge: 'start'
      },
      {
        name: '风险点名称',
        inherentRiskLevel: 1,
        existingRiskLevel: 2
      },
      {
        name: '风险点名称',
        inherentRiskLevel: 2,
        existingRiskLevel: 3
      },
      {
        name: '风险点名称',
        inherentRiskLevel: 2,
        existingRiskLevel: 3
      },
      {
        name: '风险点名称',
        inherentRiskLevel: 0,
        existingRiskLevel: 0,
        edge: 'end'
      }
    ]
  },
  {
    id: '2',
    name: '企业名称333',
    list: [
      {
        name: '3',
        inherentRiskLevel: 0, // 0-低风险 1-一般风险 2-较大风险 3-重大风险
        existingRiskLevel: 1,
        edge: 'start'
      },
      {
        name: '风险点名称',
        inherentRiskLevel: 1,
        existingRiskLevel: 2
      },
      {
        name: '风险点名称',
        inherentRiskLevel: 2,
        existingRiskLevel: 3
      },
      {
        name: '风险点名称',
        inherentRiskLevel: 2,
        existingRiskLevel: 3
      },
      {
        name: '风险点名称',
        inherentRiskLevel: 0,
        existingRiskLevel: 0,
        edge: 'end'
      }
    ]
  },
  {
    id: '3',
    name: '企业名称444',
    list: [
      {
        name: '风险点名称风险点名称风险点名称风险点名称',
        inherentRiskLevel: 0, // 0-低风险 1-一般风险 2-较大风险 3-重大风险
        existingRiskLevel: 1,
        edge: 'start'
      },
      {
        name: '风险点名称444',
        inherentRiskLevel: 1,
        existingRiskLevel: 2
      },
      {
        name: '风险点名称',
        inherentRiskLevel: 2,
        existingRiskLevel: 3
      },
      {
        name: '风险点名称',
        inherentRiskLevel: 2,
        existingRiskLevel: 3
      },
      {
        name: '风险点名称',
        inherentRiskLevel: 0,
        existingRiskLevel: 0,
        edge: 'end'
      }
    ]
  },
  {
    id: '4',
    list: [
      {
        name: '风险点名称风险点名称风险点名称风险点名称',
        inherentRiskLevel: 0, // 0-低风险 1-一般风险 2-较大风险 3-重大风险
        existingRiskLevel: 1,
        edge: 'start'
      },
      {
        name: '风险点名称',
        inherentRiskLevel: 1,
        existingRiskLevel: 2
      },
      {
        name: '风险点名称',
        inherentRiskLevel: 2,
        existingRiskLevel: 3
      },
      {
        name: '风险点名称',
        inherentRiskLevel: 2,
        existingRiskLevel: 3
      },
      {
        name: '风险点名称',
        inherentRiskLevel: 0,
        existingRiskLevel: 0,
        edge: 'end'
      }
    ]
  }
]

/**
 * @description: 地图模块-固有风险点位
 * name：企业名称
 * longitude：经度
 * latitude：纬度
 * riskLevel：风险等级，0-低风险 1-一般风险 2-较大风险 3-重大风险
 */
const inherentRiskPoints = [
  { name: '理光创想智造有限公司', longitude: 114.124911, latitude: 22.71953, riskLevel: '0' },
  { name: '深圳粤能达电力', longitude: 114.169543, latitude: 22.734374, riskLevel: '1' },
  { name: '东莞康佳电子有限公司', longitude: 114.142163, latitude: 22.74129, riskLevel: '2' },
  { name: '越华晖实业', longitude: 114.163621, latitude: 22.701517, riskLevel: '3' },
  { name: '凤岗镇政府', longitude: 114.136675, latitude: 22.74697, riskLevel: '3' }
]

/**
 * @description: 地图模块-现有风险点位
 * name：企业名称
 * longitude：经度
 * latitude：纬度
 * riskLevel：风险等级，0-低风险 1-一般风险 2-较大风险 3-重大风险
 */
const existingRiskPpints = [
  { name: '东莞康佳电子有限公司', longitude: 114.142163, latitude: 22.74129, riskLevel: '0' },
  { name: '安达工业园', longitude: 114.176195, latitude: 22.71375, riskLevel: '2' },
  { name: '东深雁田工业区', longitude: 114.167956, latitude: 22.677246, riskLevel: '3' },
  { name: '宏骏工业园', longitude: 114.182032, latitude: 22.720757, riskLevel: '3' },
  { name: '三和盛电子科技有限公司', longitude: 114.157575, latitude: 22.761375, riskLevel: '1' },
  { name: '秦广手袋厂', longitude: 114.158605, latitude: 22.741469, riskLevel: '1' }
]

export {
  overviewData,
  inherentRiskChart,
  existingRiskChart,
  enterpriseTypeChart,
  operatingStatusChart,
  riskRanking,
  riskPoints,
  riskDetails,
  inherentRiskPoints,
  existingRiskPpints
}
